import '@fontsource-variable/fraunces';
import '@fontsource-variable/inter';
import './theme/tokens.css';
import './theme/base.css';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// L'admin est chargée à la demande : les tablettes ne téléchargent jamais son code.
const AdminApp = lazy(() => import('./admin/AdminApp'));
const DisplayApp = lazy(() => import('./display/DisplayApp'));

const isAdmin = location.pathname === '/admin' || location.pathname.startsWith('/admin/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>{isAdmin ? <AdminApp /> : <DisplayApp />}</Suspense>
  </StrictMode>,
);
